<template>
    <el-container>
        <el-header>
            <commonheader :isNavShow='true'></commonheader>
        </el-header>

        <el-container class="el-container-master">
            <el-aside style="width:220px">
                <leftMenu></leftMenu>
            </el-aside>
            <el-main>
                <section class="flex">
                    <exit></exit>

                    <div class="content">
                        <div class="faceCollectCont">
                            <!-- <p class="collectTitle">首次登陆，请先进行人脸采集</p> -->
                            <p class="collectTitle">人脸采集</p>
                            <div class="cameraBox">
                                <!-- {{isCamera}} -->
                                <div class="openCamera" v-if='isCamera == 1'>电脑摄像头</div>
                                <div class="cameraContdown" v-else-if='isCamera == 2'>{{dowTime}}</div>
                                <camera v-loading='uploadLoading' @fileUpload="fileUpload" :show='isCamera == 3' v-else></camera>
                            </div>

                            <div class="cameraStyle">
                                <template v-if='!localChange'>
                                    <div class="collectBtn blueGradient" @click="startPhoto">开始人脸采集</div>
                                    <p class="cameraTips">点击按钮后5秒后将自动拍照，请注意保护隐私</p>
                                </template>
                                
                                <!-- <div class="collectBtn blueGradient" v-if='isCamera == 1'>
                                    上传照片
                                    <el-upload class="avatar-uploader" :show-file-list="false"
                                        :http-request="httpRequest" action='actionUrl'>
                                        <i class="el-icon-plus avatar-uploader-icon"></i>
                                    </el-upload>
                                </div> -->

                            </div>

                        </div>

                    </div>

                </section>
            </el-main>
        </el-container>
    </el-container>

</template>

<script>
import commonheader from '../../common/commonHeader.vue' //头部组件
import leftMenu from "../../common/leftMenu.vue"; //头部组件
import exit from "../../common/exit.vue"; //头部组件
import camera from "./Camera.vue"

export default {
    name: "index",
    components: {
        commonheader,
        exit,
        leftMenu,
        camera
    },
    data () {
        return {
            localChange:false,
            uploadLoading:false,
            isCamera:1,
            dowTime:5,
            timer:null,
            actionUrl: '',
            imageUrl: 'http://img.baitongshiji.com/data/upload/hySep/5b9615564ec1c.png'
        };
    },
    mounted: function () {
        document.getElementsByTagName("html")[0].className = "my-page";
       
    },
    beforeDestroy(){
        clearInterval(this.timer);
    },
    methods: {
       
        //点击开始人脸采集
        startPhoto(){
            if( this.isCamera != 1 ) return false;
            this.isCamera = 2;
            this.timer = setInterval(()=>{
                if( this.dowTime <= 1 ){
                    this.isCamera = 3;
                    clearInterval(this.timer);
                }
                console.log(this.dowTime)
                this.dowTime = this.dowTime - 1;
            },1000)
        },

        //本地上传
        httpRequest (options) {
            this.localChange = true;
            let file = options.file
            let filename = options.filename
            let reader = null;
            if (file) {
                reader = new FileReader()
                reader.readAsDataURL(file)
            }
            reader.onload = () => {
                this.fileUpload(reader.result);
            }
        },

        fileUpload(result){
            this.uploadLoading = true;
            this.$store.dispatch('avatar', { avatar: result }).then((res) => {
                if (res.code == 200) {
                    this.$message({
                        message: '上传成功',
                        type: 'success'
                    });
                    setTimeout(()=>{
                        localStorage.setItem('isLogin',true);
                        this.$store.commit('setLogin',true);
                        this.$router.push('/studentsNote');
                    },1000)
                }
                this.uploadLoading = false;
            }).catch(()=>{
                this.uploadLoading = false;
            })
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media (min-width: 1399px) {
    .el-container-master {
        width: 1400px;
        margin: auto;
    }
}

.el-aside {
    background: #fff;
}

.el-main {
    padding: 0;
    background: #fff;
}

.content {
    padding: 47px 57px 0 86px;
    flex: 1;
    border-top: 10px solid #f8f8f8;
    border-left: 10px solid #f8f8f8;
}

.faceCollectCont {
    padding-bottom: 30px;
}

.collectTitle {
    font-size: 22px;
    color: #666;
    text-align: center;
    margin-top: 20px;
}

.cameraBox {
    width: 400px;
    min-height: 430px;
    padding: 10px 0;
    margin: 30px auto;
    border-radius: 4px;
    border: 1px solid rgba(217, 217, 217, 1);
    background: #f8f8f8;
    position: relative;
}


.cameraContdown {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    color: #666;
    font-size: 72px;
}

.openCamera {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    color: #666;
    font-size: 14px;
    background: url("../../../assets/images/cameraIcon.png") no-repeat top center;
    padding-top: 80px;
    font-weight: bold;
}

.cameraStyle {
    padding-top: 30px;
}

.collectBtn {
    width: 290px;
    height: 42px;
    line-height: 42px;
    color: #fff;
    text-align: center;
    margin: 10px auto;
    cursor: pointer;
    border-radius: 4px;
    position: relative;
}
.collectBtn .avatar-uploader {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
}

.cameraTips {
    text-align: center;
    color: #999;
    font-size: 14px;
    margin: 10px;
}
</style>
<style lang="stylus">
.collectBtn .avatar-uploader .el-upload
    width 100% !important
    opacity 0
.cameraBox 
    .camera-p
        padding: 0 10px!important
    .camera-btn
        margin-top 10px

</style>



// WEBPACK FOOTER //
// src/components/my/faceCollection/faceCollection.vue